import type { MaterialGroup } from 'src/modules/designStudio/helpers/productSelection/types';

export enum TemplateProductCategories {
  Walls = 'Walls',
  Roof = 'Roof',
}

export type TemplateProductBreakdown = Record<
  TemplateProductCategories,
  MaterialGroup[]
>;
